<template>
  <div
    class="scrollable phyExService"
    v-loading.fullscreen.lock="fullscreenLoading"
  >
    <v-header></v-header>
    <div class="content" style="margin-bottom:70px;">
      <!-- <div class="breadNav">
        <p>个人中心</p>
      </div> -->
      <div class="order-satisfaction" v-if="isSurvey">
        <div class="satis-left">
          <img src="../../assets/提醒.svg" alt />
          <section>
            <p>
              您已完成体检，为不断提升福利体验，我们诚邀你参与本次体检的满意度调查！
            </p>
            <p class="info">
              说明：本问卷仅限员工本人作答一次，如果对体检有任何问题，请联系平台客服。
            </p>
          </section>
        </div>
        <button class="btn" @click="goSurvey">去填写</button>
      </div>
        <div
        class="reimbursement"
        v-if="isreimburseNum == 1 || isreimburseNum == 2"
      >
        <div class="left">
          抱歉，您当前所在城市暂未覆盖体检机构，您可自行至体检医院/机构完成体检，检后持票据选择此处申请报销；或利用出差/休假等机会去本平台覆盖的其他城市机构完成体检。
        </div>
        <div class="right" @click="gotoReimbursement">在线报销</div>
      </div>

      <div class="otherService">
        <div class="otherItem">
          <div class="tit">
            <p></p>
            <p>{{ $t("m.common.order") }}：</p>
          </div>
          <div class="mod">
            <div class="modList">
              <div class="modItem" @click="phyOrder(0, 0)">
                <img src="../../assets/icon/体检订单.png" />
                <p>{{ $t("m.myorder.allOrder") }}</p>
              </div>
              <div class="modItem" @click="phyOrder(1, 5)">
                <img src="../../assets/icon/待付款.png" />
                <p>待支付</p>
              </div>
              <div class="modItem" @click="phyOrder(2, 1)">
                <img src="../../assets/icon/待体检.png" />
                <p>{{ $t("m.myorder.waitingFor") }}</p>
              </div>
              <div class="modItem" @click="phyOrder(3, 2)">
                <img src="../../assets/icon/已到检.png" />
                <p>{{ $t("m.myorder.hasBeen") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="userMsg" style="margin-bottom: 32px;">
        <div class="user">
          <div class="tit">
            <p>
              <span></span>
              {{ $t("m.person.staffFilesTit") }}：
            </p>
            <p>
              <span style="padding-right: 20px;" @click="changePassBtn"
                >设置</span
              >
              <span @click="editBtn">{{ $t("m.common.editMessage") }}</span>
            </p>
          </div>
          <div class="msg">
            <div class="left">
              <div class="name">
                <p>
                  <span>{{ $t("m.staffMsg.editDialog.name") }}：</span>
                  {{ allUserMsg.name }}
                </p>
              </div>
              <div class="sex">
                <p>
                  <span>{{ $t("m.staffMsg.editDialog.sex") }}：</span>
                  {{
                    allUserMsg.gender == 0
                      ? $t("m.common.woman")
                      : $t("m.common.man")
                  }}
                </p>
              </div>
              <div class="name">
                <p v-if="!allUserMsg.contacttel">
                  <span>{{ $t("m.staffMsg.editDialog.phone") }}：</span>
                  {{ $t("m.common.unbound") }}
                </p>
                <p v-else>
                  <span>{{ $t("m.staffMsg.editDialog.phone") }}：</span>
                  {{ allUserMsg.contacttel | hidePhone }}
                </p>
              </div>
              <div class="name">
                <p>
                  <span>{{ $t("m.staffMsg.editDialog.card") }}：</span>
                  {{ allUserMsg.identity_code | hideMiddle }}
                </p>
              </div>
            </div>
            <div class="right"></div>
          </div>
        </div>
        <div class="peoNum">
          <div class="tit">
            <p>
              <span></span>
              {{ $t("m.person.phyExam") }}：
            </p>
          </div>
          <div class="peoList">
            <div class="peoData">
              <div
                class="peoItem"
                @click="editPhyPeo(item.id)"
                :data-id="item.id"
                :key="index"
                v-for="(item, index) in phyExPeoList"
              >
                <div v-if="item.relationship != 0">
                  <img
                    src="../../assets/tjpeo_icon/配偶-男.png"
                    v-if="item.gender == 1"
                  />
                  <img
                    src="../../assets/tjpeo_icon/配偶-女.png"
                    v-if="item.gender == 0"
                  />
                  <p>{{ item.name }}</p>
                </div>
              </div>
            </div>
            <div class="addPeo" @click="addPhyShow">
              <img src="../../assets/tjpeo_icon/添加人员.png" />
              <p>{{ $t("m.person.addPhy") }}</p>
            </div>
          </div>
        </div>
      </div>

    
      <div class="miaoshu">
        如果对体检或平台有任何问题，请点击<span
          @click="gotots"
          style="cursor: pointer;color: #FF000F;text-decoration: underline;"
          >投诉建议</span
        >，或拨打客服热线：<span style="color: #FF000F;"
          >400-068-5099 - 转1 - 转6688
        </span>
      </div>
    </div>

    <v-footer></v-footer>
    <!-- 编辑员工信息 -->
    <el-dialog
      :title="$t('m.staffMsg.editDialog.tit')"
      :visible.sync="dialogVisible"
      :close-on-click-modal="closeOnClickModal"
    >
      <div class="editMsg">
        <div class="name item">
          <p>{{ $t("m.staffMsg.editDialog.name") }}</p>
          <p>{{ allUserMsg.name }}</p>
        </div>
        <div class="sex item">
          <p>{{ $t("m.staffMsg.editDialog.sex") }}</p>
          <p>{{ allUserMsg.gender_value }}</p>
        </div>

        <div class="cardType item">
          <p>{{ $t("m.staffMsg.editDialog.cardType") }}</p>
          <p>
            {{
              allUserMsg.identity_type == 1
                ? $t("m.common.nationalType.idcard")
                : allUserMsg.identity_type == 2
                ? $t("m.common.nationalType.passport")
                : allUserMsg.identity_type == 3
                ? $t("m.common.nationalType.gat")
                : $t("m.common.nationalType.other")
            }}
          </p>
        </div>
        <div class="idcard item">
          <p>{{ $t("m.staffMsg.editDialog.card") }}</p>
          <p>{{ allUserMsg.identity_code }}</p>
        </div>
        <div class="mobile item" label="婚姻状况" prop="allUserMsg.marriage">
          <p>婚姻状况</p>
          <el-radio-group v-model="allUserMsg.marriage">
            <el-radio :label="0">未婚</el-radio>
            <el-radio :label="1">已婚</el-radio>
          </el-radio-group>
        </div>
        <div
          v-if="allUserMsg.gender_value == '女' && allUserMsg.marriage != null"
          class="ts"
        >
          *婚否信息会影响对应的套餐内容：选择“未婚”，则对应“无妇科检查”套餐，如需要妇科检查，请您选择“已婚”
          （妇科检查仅适用于已婚或未婚有性生活史女性，且孕期不可做）
        </div>
        <div class="mobile item">
          <p>{{ $t("m.staffMsg.editDialog.phone") }}</p>
          <input
            type="text"
            name
            :placeholder="$t('m.staffMsg.editDialog.inputPhone')"
            v-model="allUserMsg.contacttel"
            ref="getphone"
          />
        </div>
        <div v-if="yzm">
          <div class="mobile item" style="width: 70%;position: relative;">
            <p>验证码</p>
            <input
              type="text"
              name
              placeholder="请输入验证码"
              v-model="allUserMsg.code"
            />
          </div>

          <div class="djs" v-if="phomeCodeShow" @click="getCode()">
            发送验证码
          </div>
          <div class="djs1" v-else>{{ counts }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelStaff">{{
          $t("m.common.cancelBtn")
        }}</el-button>
        <el-button type="primary" :loading="dialogLoading" @click="editOkBtn">{{
          $t("m.common.define")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 修改密码 -->
    <el-dialog
      :title="$t('m.person.changePass')"
      :visible.sync="passwordVisible"
      :close-on-click-modal="closeOnClickModal"
    >
      <div class="editMsg passwordDialog">
        <div class="name item">
          <p>
            <img src="../../assets/icon/密码.svg" />
          </p>
          <input
            type="password"
            name
            :placeholder="$t('m.person.oldPassword')"
            ref="oldPasswords"
          />
        </div>
        <div class="sex item">
          <p>
            <img src="../../assets/icon/密码.svg" />
          </p>
          <input
            type="password"
            name
            :placeholder="$t('m.person.newPassword')"
            ref="newPassword"
          />
        </div>
        <div class="gender item">
          <p>
            <img src="../../assets/icon/密码.svg" />
          </p>
          <input
            type="password"
            name
            :placeholder="$t('m.person.newPasswordAgin')"
            ref="againPassword"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="passwordVisible = false">{{
          $t("m.common.cancelBtn")
        }}</el-button>
        <el-button
          type="primary"
          :loading="dialogLoading"
          @click="reviseOkBtn"
          >{{ $t("m.common.define") }}</el-button
        >
      </span>
    </el-dialog>
    <!-- 添加体检人 -->
    <el-dialog
      :title="$t('m.person.addPhy')"
      :visible.sync="addPhysicalVisible"
      :close-on-click-modal="closeOnClickModal"
    >
      <div class="editMsg">
        <div class="name item">
          <p>{{ $t("m.staffMsg.editDialog.name") }}</p>
          <input
            maxlength="30"
            type="text"
            name
            :placeholder="$t('m.staffMsg.editDialog.inputName')"
            ref="addPhyName"
          />
        </div>
        <div class="cardType item">
          <p>{{ $t("m.staffMsg.editDialog.cardType") }}</p>
          <div class="radioDiv">
            <el-dropdown
              trigger="click"
              style="cursor: pointer;"
              @command="handleCommand"
            >
              <span
                :class="
                  idcardType == $t('m.staffMsg.editDialog.chooseType')
                    ? 'el-dropdown-link'
                    : 'el-dropdown-link active'
                "
                style="width: 60%;color: #999;"
              >
                {{ idcardType }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a">{{
                  $t("m.common.nationalType.idcard")
                }}</el-dropdown-item>
                <el-dropdown-item command="b">{{
                  $t("m.common.nationalType.passport")
                }}</el-dropdown-item>
                <el-dropdown-item command="c">{{
                  $t("m.common.nationalType.gat")
                }}</el-dropdown-item>
                <el-dropdown-item command="d">{{
                  $t("m.common.nationalType.other")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="idcard item">
          <p>{{ $t("m.staffMsg.editDialog.card") }}</p>
          <input
            type="text"
            maxlength="50"
            onkeyup="value=value.replace(/[\W]/g,'')"
            name
            :placeholder="
              idcardType === '' || idcardType != '身份证'
                ? '请输入证件号'
                : '请输入证件号,X为大写'
            "
            ref="addPhyidCard"
            @input="test1"
          />
        </div>
        <div class="sex item">
          <p>{{ $t("m.staffMsg.editDialog.sex") }}</p>
          <div class="radioDiv">
            <el-radio
              v-model="sexRadio"
              label="1"
              :disabled="idcardType == '身份证'"
              >{{ $t("m.common.man") }}
            </el-radio>
            <el-radio
              v-model="sexRadio"
              label="2"
              :disabled="idcardType == '身份证'"
              >{{ $t("m.common.woman") }}
            </el-radio>
          </div>
        </div>

        <div class="sex item" v-if="isIdCard">
          <p>{{ $t("m.staffMsg.editDialog.birthday") }}</p>
          <div
            class="radioDiv"
            id="birthDate"
            style="padding-left: 10px !important;"
          >
            <el-date-picker
              v-model="birthDate"
              type="date"
              default-value="1990-01-01"
              :placeholder="$t('m.staffMsg.editDialog.chooseTime')"
            ></el-date-picker>
          </div>
        </div>
        <div class="idcard item" label="婚姻状况" prop="marriage1">
          <p>婚姻状况</p>
          <el-radio-group v-model="marriage1">
            <el-radio :label="0">未婚</el-radio>
            <el-radio :label="1">已婚</el-radio>
          </el-radio-group>
        </div>
        <div v-if="sexRadio == 2 && marriage1 != null" class="ts">
          *婚否信息会影响对应的套餐内容：选择“未婚”，则对应“无妇科检查”套餐，如需要妇科检查，请您选择“已婚”
          （妇科检查仅适用于已婚或未婚有性生活史女性，且孕期不可做）
        </div>
        <div class="idcard item">
          <p>{{ $t("m.staffMsg.editDialog.phone") }}</p>
          <input
            type="text"
            oninput="value=value.replace(/[^\d]/g,'')"
            name
            :placeholder="$t('m.staffMsg.editDialog.inputPhone')"
            ref="addPhyphone"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addPhysicalVisible = false">{{
          $t("m.common.cancelBtn")
        }}</el-button>
        <el-button
          type="primary"
          :loading="dialogLoading"
          @click="addPhyOkBtn"
          >{{ $t("m.common.define") }}</el-button
        >
      </span>
    </el-dialog>
    <!-- 编辑体检人 -->
    <el-dialog
      :title="$t('m.person.editPhy')"
      :visible.sync="editPhysicalVisible"
      :close-on-click-modal="closeOnClickModal"
    >
      <div class="editMsg">
        <div class="name item">
          <p>{{ $t("m.staffMsg.editDialog.name") }}</p>
          <input
            type="text"
            maxlength="30"
            name
            :placeholder="$t('m.staffMsg.editDialog.inputName')"
            ref="editPhyName"
            :value="editPeoMsg.name"
          />
        </div>
        <div class="cardType item">
          <p>{{ $t("m.staffMsg.editDialog.cardType") }}</p>
          <div class="radioDiv">
            <el-dropdown
              trigger="click"
              style="cursor: pointer;"
              @command="editHandleCommand"
            >
              <span
                :class="
                  editidcardType == $t('m.staffMsg.editDialog.chooseType')
                    ? 'el-dropdown-link'
                    : 'el-dropdown-link active'
                "
                style="width: 60%;color: #999;"
              >
                {{ editidcardType }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a">{{
                  $t("m.common.nationalType.idcard")
                }}</el-dropdown-item>
                <el-dropdown-item command="b">{{
                  $t("m.common.nationalType.passport")
                }}</el-dropdown-item>
                <el-dropdown-item command="c">{{
                  $t("m.common.nationalType.gat")
                }}</el-dropdown-item>
                <el-dropdown-item command="d">{{
                  $t("m.common.nationalType.other")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="idcard item">
          <p>{{ $t("m.staffMsg.editDialog.card") }}</p>
          <input
            type="text"
            maxlength="50"
            onkeyup="value=value.replace(/[\W]/g,'')"
            name
            :placeholder="
              editidcardType === '' || editidcardType != '身份证'
                ? '请输入证件号'
                : '请输入证件号,X为大写'
            "
            ref="editPhyidCard"
            @input="test"
            v-model="editPeoMsg.identity_code"
          />
        </div>
        <div class="sex item">
          <p>{{ $t("m.staffMsg.editDialog.sex") }}</p>
          <div class="radioDiv">
            <el-radio
              v-model="editsexRadio"
              label="1"
              :disabled="editidcardType === '身份证'"
              >{{ $t("m.common.man") }}
            </el-radio>
            <el-radio
              v-model="editsexRadio"
              :disabled="editidcardType === '身份证'"
              label="2"
              >{{ $t("m.common.woman") }}
            </el-radio>
          </div>
        </div>

        <div class="idcard item" label="婚姻状况" prop="allUserMsg.marriage">
          <p>婚姻状况</p>
          <el-radio-group v-model="allUserMsg.marriage">
            <el-radio :label="0">未婚</el-radio>
            <el-radio :label="1">已婚</el-radio>
          </el-radio-group>
        </div>
        <div v-if="editsexRadio == 2" class="ts">
          *婚否信息会影响对应的套餐内容：选择“未婚”，则对应“无妇科检查”套餐，如需要妇科检查，请您选择“已婚”
          （妇科检查仅适用于已婚或未婚有性生活史女性，且孕期不可做）
        </div>
        <div
          class="sex item"
          v-if="editidcardType != $t('m.common.nationalType.idcard')"
        >
          <p>{{ $t("m.staffMsg.editDialog.birthday") }}</p>
          <div
            class="radioDiv"
            id="birthDate"
            style="padding-left: 10px !important;"
          >
            <el-date-picker
              v-model="editBirthDate"
              type="date"
              default-value="1990-01-01"
              :placeholder="$t('m.staffMsg.editDialog.chooseTime')"
            ></el-date-picker>
          </div>
        </div>
        <div class="idcard item">
          <p>{{ $t("m.staffMsg.editDialog.phone") }}</p>
          <input
            type="text"
            oninput="value=value.replace(/[^\d]/g,'')"
            name
            :placeholder="$t('m.staffMsg.editDialog.inputPhone')"
            ref="editPhyphone"
            :value="editPeoMsg.contacttel"
          />
        </div>
        <div class="removePeo">
          <p @click="removePhy">{{ $t("m.person.deletePhy") }}</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editPhysicalVisible = false">{{
          $t("m.common.cancelBtn")
        }}</el-button>
        <el-button
          type="primary"
          :loading="dialogLoading"
          @click="editPhyOkBtn"
          >{{ $t("m.common.define") }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import header from "../common/header.vue";
import footer from "../common/footer.vue";

let phoneReg = /^1[3456789]\d{9}$/,
  cardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
  pwdReg = /^((?=.*[0-9])(?=.*[A-z]).{6,16})|((?=.*[A-z])(?=.*[^A-z0-9]).{6,16})|((?=.*[0-9])(?=.*[^A-z0-9]).{6,20})$/;
export default {
  name: "phyExService",
  data() {
    return {
      isSurvey: false,
      subOrderNo: "",
      dialogLoading: false,
      dialogVisible: false,
      closeOnClickModal: false,
      timer: null,
      show: true,
      isMobile: false,
      mobileVal: "",
      passwordVisible: false,
      addPhysicalVisible: false,
      sexRadio: "0",
      marryRadio: "1",
      relationRadio: "1",
      idcardType: this.$t("m.staffMsg.editDialog.chooseType"),
      // phyExPeoList:[],
      editPhysicalVisible: false,
      editsexRadio: "1",
      editmarryRadio: "1",
      editidcardType: this.$t("m.staffMsg.editDialog.chooseType"),
      editPeoMsg: {},
      birthDate: "",
      editBirthDate: "",
      isIdCard: false,
      companyName: "",
      name: "", //判断点击的是员工体检还是家属体检
      projectVisible: false,
      projectList: [],
      projectRadio: null,
      staffPhone: "",
      fullscreenLoading: false,
      free_amount: 0,
      staffSexRadio: "",
      phyExPeoList: [],
      allUserMsg: {
        contacttel: "",
        code: "",
        marriage: ""
      },
      isreimburseNum: null, //是否具备报销权限 1具备 2不具备
      phomeCodeShow: true,
      counts: "",
      marriage1: null, // 默认选中为1 0
      yzm: false
    };
  },
  components: {
    "v-header": header,
    "v-footer": footer
  },
  watch: {
    "allUserMsg.contacttel": {
      handler: function() {
        if (
          JSON.parse(sessionStorage.getItem("userMsg")).contacttel ===
          this.allUserMsg.contacttel
        ) {
          this.yzm = false;
        } else {
          // console.log(7987897)
          this.yzm = true;
        }
      }
    }
  },

  created() {
    let _this = this;
    _this.getPhysical();
    //
    _this.companyName = localStorage.getItem("companyName");
    _this.getproject();
    _this.isReimburse();
    axios
      .post(
        `${BASE_URL}/exam/satisfaction_survey/userExam/getQuestionnaireStatus/`
      )
      .then(res => {
        if (res.data.success && res.data.data) {
          if (Array.isArray(res.data.data.popup)) {
            this.subOrderNo = res.data.data.popup[0];
          } else {
            this.isSurvey = res.data.data.popup;
            this.subOrderNo = res.data.data.orderNo;
          }
        }
      });
      axios.get(BASE_URL + "/exam/projects/").then(res1 => {
        console.log(res1)
        sessionStorage.setItem('project',JSON.stringify(res1.data.data[0]))
      })
  },
  filters: {
    hideMiddle(val) {
      if (val) {
        return `${val.substring(0, 4)}****${val.substring(val.length - 4)}`;
      }
    },
    hidePhone(p) {
      if (p) {
        return p.substring(0, 3) + "****" + p.substring(p.length - 4);
      }
    }
  },
  methods: {
    ...mapActions(
      // 语法糖
      ["message"] // 相当于this.$store.dispatch('modifyName'),提交这个方法
    ),
    goSurvey() {
      this.$router.push({
        path: "/investigate",
        query: {
          subOrderNo: this.subOrderNo
        }
      });
    },
    getPhysical() {
      let _this = this;
      _this.fullscreenLoading = true;
      axios
        .get(BASE_URL + "/exam/relatives/")
        .then(res => {
          _this.fullscreenLoading = false;
          _this.phyExPeoList = res.data.data;

          _this.phyExPeoList.forEach(function(element) {
            if (element.relationship === 0) {
              _this.allUserMsg = element;
              _this.staffSexRadio = element.gender;
            }
          });
        })
        .catch(err => {
          _this.fullscreenLoading = false;
        });
    },
    //跳转到在线报销页面
    gotoReimbursement() {
      this.$router.push("/reimburse");
    },
    // 是否显示在线报销
    isReimburse() {
      axios
        .get(BASE_URL + "/exam/invoice/check/")
        .then(res2 => {
          this.fullscreenLoading = false;
          this.isreimburseNum = Number(res2.data.data.invoice_power);
        })
        .catch(err => {
          this.fullscreenLoading = false;
        });
    },
    cancelStaff() {
      let _this = this;
      this.dialogVisible = false;
      _this.getPhysical();
    },
    gotots() {
      this.$router.push({
        path: "/Suggestions1"
      });
    },
    //取项目id，获取美团免费权益个数
    getproject() {
      this.fullscreenLoading = true;
      axios.get(BASE_URL + "/exam/projects/").then(res => {
        let projectId = res.data.data[0].id;
        let params = {
          pid: projectId
        };
        axios
          .get(BASE_URL + "/exam/mt/relatives/benefit/", {
            params: params
          })
          .then(res2 => {
            this.fullscreenLoading = false;
            this.free_amount = res2.data.data.free_amount;
          })
          .catch(err => {
            this.fullscreenLoading = false;
          });
      });
    },
    //点击修改密码按钮
    changePassBtn() {
      let _this = this;
      if (!_this.allUserMsg.contacttel) {
        let data = {
          message: _this.$t("m.person.bdPhone"),
          type: "error",
          center: true
        };
        _this.message(data);
      } else {
        _this.passwordVisible = true;
        _this.$refs.oldPasswords.value = "";
        _this.$refs.newPassword.value = "";
        _this.$refs.againPassword.value = "";
      }
    },
    //跳转体检订单页面
    phyOrder(num, type) {
      let _this = this;
      _this.$router.push({
        path: "/phyOrderList",
        query: {
          check: num,
          statusType: type
        }
      });
    },
    //跳转体检报告页面
    phyReport() {
      let _this = this;
      _this.$router.push({
        path: "/medicalReports"
      });
    },
    //删除体检人
    removePhy() {
      let _this = this;
      _this
        .$confirm(_this.$t("m.person.isDelete"))
        .then(_ => {
          //删除体检人接口
          axios
            .delete(BASE_URL + "/exam/relatives/" + _this.editPeoMsg.id + "/")
            .then(res => {
              // console.log(res);
              _this.editPhysicalVisible = false;
              _this.getPhysical();
              let data = {
                message: _this.$t("m.person.deleteSuccess"),
                type: "success",
                center: true
              };
              _this.message(data);
            });
        })
        .catch(_ => {});
    },
    //点击体检人列表弹出编辑弹窗
    editPhyPeo(id) {
      let _this = this;
      _this.fullscreenLoading = true;

      //点击体检人获取体检人详情
      axios
        .get(BASE_URL + "/exam/relatives/" + id + "/")
        .then(res => {
          // console.log(res);
          _this.fullscreenLoading = false;
          _this.editPhysicalVisible = true;
          _this.editPeoMsg = res.data.data;
          if (res.data.data.gender == 0) {
            _this.editsexRadio = "2";
          } else {
            _this.editsexRadio = "1";
          }
          if (res.data.data.marriage == 1) {
            _this.marriage1 = "1";
          } else {
            _this.marriage1 = "0";
          }

          if (res.data.data.marriage == 0) {
            _this.editmarryRadio = "2";
          } else {
            _this.editmarryRadio = "1";
          }
          _this.allUserMsg.marriage = res.data.data.marriage;
          console.log(_this.allUserMsg.marriage);
          if (res.data.data.identity_type == 0) {
            _this.editidcardType = _this.$t("m.common.nationalType.idcard");
          } else if (res.data.data.identity_type == 1) {
            _this.editidcardType = _this.$t("m.common.nationalType.passport");
          } else if (res.data.data.identity_type == 2) {
            _this.editidcardType = _this.$t("m.common.nationalType.gat");
          } else if (res.data.data.identity_type == 3) {
            _this.editidcardType = _this.$t("m.common.nationalType.other");
          }

          _this.editBirthDate = res.data.data.birthday;
        })
        .catch(err => {
          _this.fullscreenLoading = false;
        });
    },
    test() {
      if (
        this.editPeoMsg.identity_code.length == 18 &&
        this.editidcardType == "身份证"
      ) {
        if (parseInt(this.editPeoMsg.identity_code.charAt(16)) % 2 == 1) {
          this.editsexRadio = "1";
        } else {
          this.editsexRadio = "2";
        }
      }
    },
    test1() {
      console.log(this.$refs.addPhyidCard.value);
      if (
        this.$refs.addPhyidCard.value.length == 18 &&
        this.idcardType == "身份证"
      ) {
        if (parseInt(this.$refs.addPhyidCard.value.charAt(16)) % 2 == 1) {
          this.sexRadio = "1";
        } else {
          this.sexRadio = "2";
        }
      }
    },
    //点击编辑体检人弹窗的确定按钮
    editPhyOkBtn() {
      let _this = this;
      let phoneReg = /^1[3456789]\d{9}$/;
      //校验参数
      if (_this.$refs.editPhyName.value == "") {
        let data = {
          message: _this.$t("m.person.editError.name"),
          type: "error",
          center: true
        };
        _this.message(data);
      } else if (
        _this.editidcardType == _this.$t("m.staffMsg.editDialog.chooseType")
      ) {
        let data = {
          message: _this.$t("m.person.editError.type"),
          type: "error",
          center: true
        };
        _this.message(data);
      } else if (_this.$refs.editPhyidCard.value == "") {
        let data = {
          message: _this.$t("m.person.editError.card"),
          type: "error",
          center: true
        };
        _this.message(data);
      } else if (_this.$refs.editPhyphone.value == "") {
        let data = {
          message: _this.$t("m.person.editError.phone"),
          type: "error",
          center: true
        };
        _this.message(data);
      } else if (
        _this.$refs.editPhyphone.value.indexOf("*") == -1 &&
        !phoneReg.test(_this.$refs.editPhyphone.value)
      ) {
        console.log(_this.$refs.editPhyphone.value);
        let data = {
          message: _this.$t("m.person.editError.okPhone"),
          type: "error",
          center: true
        };
        _this.message(data);
      } else {
        //整理添加体检人需要传的参数
        let params = {
          name: _this.$refs.editPhyName.value,
          identity_code: _this.$refs.editPhyidCard.value,
          // contacttel:_this.$refs.editPhyphone.value,
          relationship: _this.editPeoMsg.relationship,
          marriage: _this.allUserMsg.marriage
        };
        if (_this.$refs.editPhyphone.value.indexOf("*") != -1) {
          params.contacttel = this.editPeoMsg.contacttel;
        } else {
          params.contacttel = _this.$refs.editPhyphone.value;
        }
        // console.log(_this.editsexRadio);

        // if(_this.editmarryRadio == '1'){
        // 	params.marriage = 1;
        // }else if(_this.editmarryRadio == '2'){
        // 	params.marriage = 0;
        // }

        if (_this.editidcardType == _this.$t("m.common.nationalType.idcard")) {
          params.identity_type = 0;
        } else {
          if (
            _this.editidcardType == _this.$t("m.common.nationalType.passport")
          ) {
            params.identity_type = 1;
          } else if (
            _this.editidcardType == _this.$t("m.common.nationalType.gat")
          ) {
            params.identity_type = 2;
          } else if (
            _this.editidcardType == _this.$t("m.common.nationalType.other")
          ) {
            params.identity_type = 3;
          }

          if (_this.editsexRadio == "1") {
            params.gender = 1;
          } else if (_this.editsexRadio == "2") {
            params.gender = 0;
          }
          // if (_this.marriage1 == "0") {
          //    params.marriage = _this.marriage1
          // } else {
          //     params.marriage = _this.marriage1
          // }

          params.birthday = _this.changeTime(_this.editBirthDate);
        }
        console.log(params);
        // console.log(_this.relationRadio,_this.sexRadio,_this.marryRadio)
        _this.dialogLoading = true;
        //编辑体检人接口
        axios
          .put(
            BASE_URL + "/exam/abb/relatives/" + _this.editPeoMsg.id + "/",
            params
          )
          .then(res => {
            console.log(_this.allUserMsg.marriage);
            _this.editPhysicalVisible = false;
            _this.dialogLoading = false;
            _this.getPhysical();
            let data = {
              message: _this.$t("m.person.editSuccess"),
              type: "success",
              center: true
            };
            _this.message(data);
          })
          .catch(err => {
            _this.dialogLoading = false;
          });
      }
    },
    //点击显示添加体检人弹窗
    addPhyShow() {
      let _this = this;
      _this.addPhysicalVisible = true;
      _this.$refs.addPhyName.value = "";
      _this.idcardType = _this.$t("m.staffMsg.editDialog.chooseType");
      _this.relationRadio = "1";
      _this.birthDate = "";
      _this.$refs.addPhyphone.value = "";
      _this.$refs.addPhyidCard.value = "";
      _this.marryRadio = "1";
      _this.sexRadio = "0";
      _this.isIdCard = false;
      _this.marriage1 = null;
    },
    //点击添加体检人弹窗的确定按钮
    addPhyOkBtn() {
      let _this = this;
      console.log(_this.marriage1);
      //校验参数
      if (_this.$refs.addPhyName.value == "") {
        let data = {
          message: _this.$t("m.person.editError.name"),
          type: "error",
          center: true
        };
        _this.message(data);
      } else if (
        _this.idcardType == _this.$t("m.staffMsg.editDialog.chooseType")
      ) {
        let data = {
          message: _this.$t("m.person.editError.type"),
          type: "error",
          center: true
        };
        _this.message(data);
      } else if (_this.$refs.addPhyidCard.value == "") {
        let data = {
          message: _this.$t("m.person.editError.card"),
          type: "error",
          center: true
        };
        _this.message(data);
      } else if (
        _this.idcardType == _this.$t("m.common.nationalType.idcard") &&
        !cardReg.test(_this.$refs.addPhyidCard.value)
      ) {
        let data = {
          message: _this.$t("m.person.editError.okCard"),
          type: "error",
          center: true
        };
        _this.message(data);
      } else if (
        _this.idcardType != _this.$t("m.common.nationalType.idcard") &&
        _this.birthDate == ""
      ) {
        let data = {
          message: _this.$t("m.person.editError.birth"),
          type: "error",
          center: true
        };
        _this.message(data);
      } else if (_this.$refs.addPhyphone.value == "") {
        let data = {
          message: _this.$t("m.person.editError.phone"),
          type: "error",
          center: true
        };
        _this.message(data);
      } else if (!phoneReg.test(_this.$refs.addPhyphone.value)) {
        let data = {
          message: _this.$t("m.person.editError.okPhone"),
          type: "error",
          center: true
        };
        _this.message(data);
      } else if (_this.marriage1 == null) {
        let data = {
          message: "请选择婚姻状况",
          type: "error",
          center: true
        };
        _this.message(data);
      } else {
        //整理添加体检人需要传的参数
        let params = {
          name: _this.$refs.addPhyName.value,
          identity_code: _this.$refs.addPhyidCard.value,
          contacttel: _this.$refs.addPhyphone.value,
          marriage: _this.marriage1
        };
        // if(_this.relationRadio == '1'){
        // 	params.relationship = 2;
        // }else if(_this.relationRadio == '2'){
        // 	params.relationship = 1;
        // }else if(_this.relationRadio == '3'){
        // 	params.relationship = 4;
        // }

        // if(_this.marryRadio == '1'){
        // 	params.marriage = 1;
        // }else if(_this.marryRadio == '2'){
        // 	params.marriage = 0;
        // }

        if (_this.idcardType == _this.$t("m.common.nationalType.idcard")) {
          params.identity_type = 0;
        } else {
          if (_this.idcardType == _this.$t("m.common.nationalType.passport")) {
            params.identity_type = 1;
          } else if (
            _this.idcardType == _this.$t("m.common.nationalType.gat")
          ) {
            params.identity_type = 2;
          } else if (
            _this.idcardType == _this.$t("m.common.nationalType.other")
          ) {
            params.identity_type = 3;
          }
          if (_this.sexRadio == "1") {
            params.gender = 1;
          } else if (_this.sexRadio == "2") {
            params.gender = 0;
          }
          params.birthday = _this.changeTime(_this.birthDate);
        }
        // console.log(params)
        _this.dialogLoading = true;
        //添加体检人接口
        axios
          .post(BASE_URL + "/exam/relatives/", params)
          .then(res => {
            // console.log(res);
            _this.addPhysicalVisible = false;
            _this.dialogLoading = false;
            _this.getPhysical();
            let data = {
              message: _this.$t("m.person.addSuccess"),
              type: "success",
              center: true
            };
            _this.message(data);
          })
          .catch(err => {
            _this.dialogLoading = false;
          });
      }
    },
    //转化时间
    changeTime(time) {
      // console.log(time);
      var mytime = new Date(time);
      // console.log(mytime)
      var year = mytime.getFullYear(),
        month = ("0" + (mytime.getMonth() + 1)).slice(-2),
        date = ("0" + mytime.getDate()).slice(-2);
      var dateStr = year + "-" + month + "-" + date;
      return dateStr;
    },

    //点击选择证件类型
    handleCommand(command) {
      let _this = this;
      if (command == "a") {
        _this.idcardType = _this.$t("m.common.nationalType.idcard");
        _this.isIdCard = false;
      } else if (command == "b") {
        _this.idcardType = _this.$t("m.common.nationalType.passport");
        _this.isIdCard = true;
      } else if (command == "c") {
        _this.idcardType = _this.$t("m.common.nationalType.gat");
        _this.isIdCard = true;
      } else if (command == "d") {
        _this.idcardType = _this.$t("m.common.nationalType.other");
        _this.isIdCard = true;
      }
    },
    //编辑体检人选择证件类型
    editHandleCommand(command) {
      let _this = this;
      if (command == "a") {
        _this.editidcardType = _this.$t("m.common.nationalType.idcard");
      } else if (command == "b") {
        _this.editidcardType = _this.$t("m.common.nationalType.passport");
      } else if (command == "c") {
        _this.editidcardType = _this.$t("m.common.nationalType.gat");
      } else if (command == "d") {
        _this.editidcardType = _this.$t("m.common.nationalType.other");
      }
    },
    //点击账户安全
    security() {
      let _this = this;
      _this.$router.push({
        path: "/accountSecurity"
      });
    },
    //点击修改密码弹窗里面的确定
    reviseOkBtn() {
      let _this = this;

      if (_this.$refs.oldPasswords.value == "") {
        let data = {
          message: _this.$t("m.person.oldPassword"),
          type: "error",
          center: true
        };
        _this.message(data);
      } else if (_this.$refs.newPassword.value == "") {
        let data = {
          message: _this.$t("m.person.newPassword"),
          type: "error",
          center: true
        };
        _this.message(data);
      } else if (!pwdReg.test(_this.$refs.newPassword.value)) {
        let data = {
          message: _this.$t("m.common.pwdRules"),
          type: "error",
          center: true
        };
        _this.message(data);
      } else if (_this.$refs.againPassword.value == "") {
        let data = {
          message: _this.$t("m.person.newPasswordAgin"),
          type: "error",
          center: true
        };
        _this.message(data);
      } else if (
        _this.$refs.againPassword.value != _this.$refs.newPassword.value
      ) {
        let data = {
          message: _this.$t("m.person.passwordAtypism"),
          type: "error",
          center: true
        };
        _this.message(data);
      } else {
        _this.dialogLoading = true;
        axios
          .put(BASE_URL + "/exam/account/password/", {
            old_password: _this.$refs.oldPasswords.value,
            new_password: _this.$refs.newPassword.value
          })
          .then(res => {
            // console.log(res);
            _this.dialogLoading = false;
            _this.passwordVisible = false;
            let data = {
              message: _this.$t("m.person.changePassSuccess"),
              type: "success",
              center: true
            };
            _this.message(data);
            _this.$router.push({
              path: "/"
            });
            localStorage.clear();
            sessionStorage.clear();
          })
          .catch(err => {
            _this.dialogLoading = false;
          });
      }
    },

    //点击编辑员工信息弹框的确定
    editOkBtn() {
      console.log(this.allUserMsg);
      if (
        JSON.parse(sessionStorage.getItem("userMsg")).contacttel !=
        this.allUserMsg.contacttel
      ) {
        if (this.allUserMsg.code == null && this.yzm == true) {
          let data = {
            message: "请输入验证码",
            type: "error",
            center: true
          };
          this.message(data);
        }
      }
      if (
        this.allUserMsg.contacttel == "" ||
        this.allUserMsg.contacttel == undefined
      ) {
        this.$message({
          message: "请填写手机号",
          type: "error",
          center: true
        });
      } else if (this.allUserMsg.marriage === "") {
        this.$message({
          message: "请选择婚姻状况",
          type: "error",
          center: true
        });
      } else {
        axios
          .post(BASE_URL + `/exam/relatives/update/mobile/`, {
            mobile: this.allUserMsg.contacttel,
            token: this.allUserMsg.code,
            marriage: this.allUserMsg.marriage,
            project: JSON.parse(sessionStorage.getItem("project")).id
          })
          .then(res => {
            if (res.data.return_code == 0) {
              this.$message.success("修改成功");
              this.dialogVisible = false;
              axios
                .get(BASE_URL + "/exam/relatives/")
                .then(res1 => {
                  this.fullscreenLoading = false;
                  res1.data.data.forEach(function(element) {
                    sessionStorage.setItem("userMsg", JSON.stringify(element));
                  });
                })
                .catch(err => {
                  _this.fullscreenLoading = false;
                });
            }
          });
      }
    }, // 获取验证码
    getCode() {
      if (!this.allUserMsg.contacttel) {
        this.$message({
          message: "请填写手机号",
          type: "error",
          center: true
        });
      } else if (!phoneReg.test(this.allUserMsg.contacttel)) {
        this.$message({
          message: "请填写正确的手机号",
          type: "error",
          center: true
        });
      } else {
        let _this = this;
        axios
          .post(BASE_URL + `/exam/relatives/update/token/`, {
            mobile: this.allUserMsg.contacttel,
            project: JSON.parse(sessionStorage.getItem("project")).id
          })
          .then(res => {
            let TIME_COUNT = 60;
            if (!_this.timer) {
              _this.counts = TIME_COUNT;
              _this.phomeCodeShow = false;
              _this.timer = setInterval(() => {
                if (_this.counts > 0 && _this.counts <= TIME_COUNT) {
                  _this.counts--;
                } else {
                  _this.phomeCodeShow = true;
                  clearInterval(_this.timer);
                  _this.timer = null;
                }
              }, 1000);
            }
          });
      }
    },
    //点击编辑信息文字
    editBtn() {
      let _this = this;
      _this.dialogVisible = true;
      // _this.$refs.getCode.value = '';
      _this.isMobile = false;
      _this.mobileVal = "";
      _this.show = true;
      _this.yzm = false;
      _this.allUserMsg.code = null;
      _this.counts = 0;
    },
    //退出功能
    quit() {
      let _this = this;
      _this
        .$confirm(_this.$t("m.common.isQuit"), {
          confirmButtonText: _this.$t("m.common.define"),
          cancelButtonText: _this.$t("m.common.cancelBtn")
          // type: 'warning'
        })
        .then(() => {
          sessionStorage.clear();
          _this.$store.dispatch("quitUser");
          _this.$router.replace({
            path: "/"
          });
          let data = {
            message: _this.$t("m.common.quitSuccess"),
            type: "info",
            center: true
          };
          _this.message(data);
        })
        .catch(() => {});
    }
  },
  computed: {
    ...mapGetters(["userMsg"]) // 动态计算属性，相当于this.$store.getters.resturantName
  },
  mounted() {
    // console.log('mounted')
    // console.log(_this.allUserMsg)
  }
};
</script>

<style scoped lang="scss">
/*@import "../../../node_modules/swiper/css/swiper.css"*/

.order-satisfaction {
  width: 1180px !important;
  margin: 0 auto;
  margin-top: 50px;
  padding: 25px 30px;
  width: 100%;
  background: #fff;
  // height: 184px;
  border: 1px solid #cccccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .satis-left {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 34px;
    .info {
      font-size: 16px;
      font-weight: 400;
      color: #333;
    }
    img {
      width: 60px;
      height: 60px;
      margin-right: 20px;
    }
  }
  .btn {
    width: 180px;
    height: 46px;
    background: #ff000f;
    font-size: 16px;
    border-radius: 23px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 46px;
    cursor: pointer;
  }
}

.removePeo {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.removePeo p {
  text-decoration: underline;
  color: #ff000f;
  font-size: 16px;
  line-height: 16px;
  cursor: pointer;
}

.active {
  color: #333 !important;
}

.passwordDialog .item p:first-child {
  width: 40px !important;
  display: flex;
  justify-content: center;
}

.getcode {
  width: 92px;
  height: 30px;
  background: #999999;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  line-height: 16px;
  margin-right: 10px;
  cursor: pointer;
}

.editMsg {
  width: 100%;
}

.editMsg .item {
  width: 100%;
  height: 50px;
  border: 1px solid #dfdfdf;
  border-radius: 4px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.editMsg .item p:first-child {
  width: 120px;
  text-align: center;
  /*padding: 17px 20px;*/
  font-size: 16px;
  font-weight: 400;
  color: #999;
  line-height: 16px;
}

.editMsg .item p:last-child {
  height: 30px;
  font-size: 16px;
  font-weight: 400;
  color: #999;
  line-height: 16px;
  display: flex;
  align-items: center;
  border-left: 1px solid #dfdfdf;
  padding-left: 20px;
}

.editMsg .item input {
  width: 60%;
  height: 30px;
  font-size: 16px;
  font-weight: 400;
  color: #333;
  line-height: 16px;
  display: flex;
  align-items: center;
  border-left: 1px solid #dfdfdf;
  padding-left: 20px;
}

.editMsg .item .radioDiv {
  width: 70%;
  height: 30px;
  font-size: 16px;
  font-weight: 400;
  color: #333;
  line-height: 16px;
  display: flex;
  align-items: center;
  border-left: 1px solid #dfdfdf;
  padding-left: 20px;
}

.content .top {
  width: 100%;
  height: 80px;
  border-bottom: 2px solid #eaeaea;
}

.content .top .topMsg {
  width: 1180px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
}

.content .top .topMsg p:first-child {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  line-height: 20px;
}

.content .top .topMsg p:last-child {
  font-size: 24px;
  font-weight: bold;
  color: #ff000f;
  line-height: 24px;
}

.breadNav {
  width: 100%;
  height: 80px;
  border-bottom: 2px solid #eaeaea;
  display: flex;
  align-items: center;
}

.breadNav p {
  width: 1180px;
  margin: 0 auto;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  line-height: 20px;
}

.userMsg {
  width: 1180px;
  height: 240px;
  border: 1px solid #ccc;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  align-items: center;
}

.reimbursement {
  width: 1180px;
  height: 78px;
  border: 1px solid #ccc;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  padding-top: 15px;
}

.reimbursement .left {
  font-size: 18px;
  font-weight: 600;
  float: left;
  width: 90%;
  padding-left: 30px;
  color: #333333;
}

.reimbursement .right {
  font-size: 18px;
  font-weight: 600;
  float: right;
  cursor: pointer;
  margin-right: 30px;
  color: #ff000f;
  text-decoration: underline;
}

.userMsg .user,
.userMsg .peoNum {
  width: 50%;
  border-right: 1px solid #eaeaea;
  height: 220px;
  padding: 14px 30px 30px 30px;
}

.userMsg .user .tit {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.userMsg .user .tit p:first-child,
.userMsg .peoNum .tit p:first-child {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  line-height: 24px;
  display: flex;
}

.userMsg .user .tit p:first-child span,
.userMsg .peoNum .tit p:first-child span {
  width: 4px;
  height: 24px;
  background: #ff000f;
  display: inline-block;
  margin-right: 7px;
}

.userMsg .user .tit p:last-child span {
  font-size: 16px;
  font-weight: 400;
  color: #ff000f;
  line-height: 15px;
  text-decoration: underline;
  cursor: pointer;
}

.userMsg .user .msg {
  display: flex;
  align-items: center;
}

.userMsg .user .msg .left {
  width: 360px;
  margin-top: 30px;
}

.userMsg .user .msg .left .name {
  display: flex;
  justify-content: space-between;
}

.userMsg .user .msg .left div {
  margin-bottom: 20px;
}

.userMsg .user .msg .left div p {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  line-height: 18px;
}

.userMsg .user .msg .left div p span {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 18px;
}

.userMsg .user .msg .right p:nth-child(1) {
  width: 164px;
  font-size: 50px;
  font-weight: 600;
  color: #ff000f;
  line-height: 40px;
  display: flex;
  justify-content: center;
}

.userMsg .user .msg .right p:nth-child(2) {
  width: 164px;
  font-size: 16px;
  font-weight: 600;
  color: #ff000f;
  line-height: 16px;
  display: flex;
  justify-content: center;
  text-decoration: underline;
  cursor: pointer;
  margin-top: 15px;
}

.userMsg .peoNum {
  width: 50%;
  height: 220px;
}

.peoList {
  margin-top: 37px;
  display: flex;
  /* margin-left: 30px; */
}

.peoList .addPeo {
  width: 100px;
  cursor: pointer;
}

.peoList .addPeo img {
  width: 100px;
  height: 100px;
}

.peoList .addPeo p {
  width: 100px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #333;
  line-height: 14px;
  margin-top: 5px;
}

.peoList .peoData {
  display: flex;
  -webkit-overflow-scrolling: touch;
  overflow: auto;
  overflow-y: hidden;
  padding-bottom: 10px;
  overflow: -moz-scrollbars-none;
  overflow: -moz-scrollbars-none;
}

.peoList .peoData .peoItem {
  width: 100px;
  cursor: pointer;
  margin-right: 30px;
  width: 100%;
}

.peoList .peoData .peoItem img {
  width: 100px;
  height: 100px;
}

.peoList .peoData .peoItem p {
  width: 100px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #333;
  line-height: 14px;
  margin-top: 5px;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}
/*.peoList .peoData::-webkit-scrollbar {
display:none;
}*/

.peoList .peoData::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 0;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 5px;
}

.peoList .peoData:hover::-webkit-scrollbar {
  width: 10px;
}

.peoList .peoData::-webkit-scrollbar-thumb {
  border-radius: 5px;
  box-shadow: inset 0 0 0 5px;
  /*background: #ededed;*/
  /* 用box-shadow模拟滚动条 */
}

.peoList .peoData::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  /*-webkit-box-shadow: inset 0 0 5px rgba(2, 128, 201, 0.2);*/
  border-radius: 10px;
  background: #eaeaea;
}

.otherService {
  width: 1180px;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 32px;
  display: flex;
  justify-content: space-between;
}

.otherService .otherItem {
  width: 100%;
  border: 1px solid #ccc;
}

.otherService .otherItem .tit {
  width: 100%;
  padding: 33px 0 0 30px;
  display: flex;
  align-items: center;
}

.otherService .otherItem .tit p:first-child {
  width: 4px;
  height: 24px;
  background: #ff000f;
}

.otherService .otherItem .tit p:last-child {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  line-height: 24px;
  margin-left: 7px;
}

.otherService .otherItem .mod {
  margin-bottom: 42px;
}

.otherService .otherItem .mod .modList {
  display: flex;
}

.otherService .otherItem .mod .modItem {
  width: 190px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin-top: 40px;
  cursor: pointer;
}

.otherService .otherItem .mod .modItem img {
  width: 40px;
  height: 40px;
  margin: 0 auto;
}

.otherService .otherItem .mod .modItem p {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 20px;
  margin-top: 30px;
}

.otherService .my {
  width: 380px;
  border: 1px solid #ccc;
}

.otherService .settings {
  width: 380px;
  border: 1px solid #ccc;
}

.ts {
  margin-bottom: 20px;
}

.miaoshu {
  width: 1180px;
  margin: 0 auto;
  text-align: center;
  font-size: 18px;
  margin-top: 30px;
}

.djs {
  width: 20%;
  height: 50px;
  position: absolute;
  bottom: 123px;
  text-align: center;
  background: #ff000f;
  line-height: 50px;
  border-radius: 5px;
  color: #fff;
  right: 35px;
}

.djs1 {
  width: 20%;
  height: 50px;
  position: absolute;
  bottom: 123px;
  text-align: center;
  background: #c5c5c5;
  line-height: 50px;
  border-radius: 5px;
  color: #fff;
  right: 35px;
}
.ts {
  padding-left: 105px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/personal/personal.vue